module.exports = __webpack_public_path__ + "assets/img/page1-design-side-nav-expanded-2-dc33f63a.png";